export const content = {
  namespaced: true,
  state: {
    memberPlaceholders: [
      {
        text: `Chat Link`,
        placeholder: `{{@chat(it.member.member_tg_id, it.member.first_name)/}}`
      },
      {
        text: `First Name`,
        placeholder: `{{it.member.first_name}}`
      },
      {
        text: `Last Name`,
        placeholder: `{{it.member.last_name}}`
      },
      {
        text: `Email`,
        placeholder: `{{it.member.email}}`
      },
      {
        text: `Cell`,
        placeholder: `{{it.member.cell}}`
      },
      {
        text: `Physical Address`,
        placeholder: `{{it.member.physical_address}}`
      },
      {
        text: `Postal Address`,
        placeholder: `{{it.member.postal_address}}`
      }
    ],
    features: [
      {
        type: "base",
        icon: "mdi-account-plus",
        title: "Group Registration",
        text: [
          "Have members register before <b>allowing access</b> to your group/s.",
          "Non-registered members can be <b>blocked from joining</b> your group.",
          "You can choose what <b>information is required</b> for registration.",
          "Only allow registration within a <b>geofenced area</b> or using a <b>restrict file</b> (containing phone numbers of allowed members)."
        ]
      },
      {
        type: "base",
        icon: "mdi-plus-box-multiple",
        title: "Elaborators",
        text: [
          "Receive messages on groups that require you to ask the sender to elaborate?",
          "Elaborators are special actions that can be triggered using actions.",
          "They prompt the user with a series of questions, the answers of which you can use to build a standardized message."
        ]
      },
      {
        type: "base",
        icon: "mdi-arrow-right-circle",
        title: "Actions",
        text: [
          "Trigger actions based on message content.",
          "A trigger can be a command, a keyword, media content or some special triggers.",
          "Actions can then be performed with the message, including logging, forwarding, requiring approval and more!"
        ]
      },
      {
        type: "base-more",
        icon: "mdi-message-text",
        title: "Message Log",
        text: [
          "Your message log (messages that triggered an action and are logged) presents messages similarly to any web based email client.",
          "You can search and view message details and view elaborator built messages alongside the original message.",
          "Elaborator data can also be viewed."
        ]
      },
      {
        type: "base-more",
        icon: "mdi-account-multiple",
        title: "Members",
        text: [
          "List your members and see their details in a conveniently searchable table.",
          "Visualise your member locations (if location is enabled for registration) on a map.",
          ""
        ]
      },
      {
        type: "base-more",
        icon: "mdi-information",
        title: "Information Commands",
        text: [
          "Always need to resend the same information to group members?",
          "You can save information content such as important phone number, instructions etc. and members can view those using a simple command.",
          ""
        ]
      }
    ]
  },
  getters: {
    features: state => state.features,
    memberPlaceholders: state => state.memberPlaceholders
  }
}